import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { GeoDataInfo } from '@shared/components/map/models/map';
import { Select, Store } from '@ngxs/store';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { GetCatalogGeoData } from '@shared/state/catalog/shared-catalog.action';
import { Observable, Subject } from 'rxjs';
import { CatalogView } from '@shared/models/shared-catalog.state';
import { map, take, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { setLocationQueryParams } from '@utils/other-utils';
import { Location } from '@angular/common';
import { TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { CatalogService } from '@shared/services/catalog.service';
import { CatalogItemsState } from '../../store/catalog-items-state';
import { GetSelectCatalogItem, SelectCatalogItemShared } from '../../../../store/catalog/catalog.action';
import { CatalogItemsQueryParams } from '../../models/catalog-item-component';
import { ChangeCatalogItem, SetIsDynamic } from '../../store/catalog-items.actions';

@Component({
  selector: 'app-catalog-map',
  templateUrl: './catalog-map.component.html',
  styleUrls: ['./catalog-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class CatalogMapComponent implements OnInit {
  public componentDestroy: () => Subject<any>;
  public selectCatalog: CatalogView;
  public clustered = false;
  public showCard = false;
  public isDynamic: boolean;
  @Select(SharedCatalogState.geoData) public geoData$: Observable<GeoDataInfo[]>;
  public mapGeoData: GeoDataInfo[] | null;
  public criteria$: Observable<string>;
  constructor(
    private activeRoute: ActivatedRoute,
    private store: Store,
    private location: Location,
    private router: Router,
    private catalogService: CatalogService
  ) {}

  private getStoreParams(): void {
    const params = this.activeRoute.snapshot.queryParams as CatalogItemsQueryParams;

    if (params?.isDynamic && params.isDynamic === 'true') {
      this.isDynamic = true;
      this.store.dispatch(new SetIsDynamic(this.isDynamic, false));
    } else {
      const currentCatalogItem = this.store.selectSnapshot(CatalogItemsState.getCatalogItem).call(this, this.selectCatalog.id);

      if (this.store.selectSnapshot(SharedCatalogState.selectCatalog)) {
        this.isDynamic = this.store.selectSnapshot(SharedCatalogState.selectCatalog).isDynamic;
        this.store.dispatch(new SetIsDynamic(this.isDynamic, false));
      } else if (currentCatalogItem) {
        if (currentCatalogItem.isDynamic !== undefined) {
          this.isDynamic = currentCatalogItem.isDynamic;
          setLocationQueryParams({ isDynamic: this.isDynamic }, this.router, this.location);
        }
      }
    }
  }

  public ngOnInit(): void {
    this.selectCatalog = this.store.selectSnapshot(SharedCatalogState.selectCatalog);
    if (this.selectCatalog) {
      this.getStoreParams();
      this.clustered = this.selectCatalog?.cluster;
      this.criteria$ = this.store.select(CatalogItemsState.getCatalogItemCriteria).pipe(
        map(filterFn => filterFn(this.selectCatalog.id)),
        tap(criteria => {
          const isRecommendationData =
            this.store.selectSnapshot(CatalogItemsState.getCatalogItemIsRecommendationData).call(this, this.selectCatalog.id) ?? false;

          const nextToMyData = this.store.selectSnapshot(CatalogItemsState.getCatalogItemIsNextToMeData).call(this, this.selectCatalog.id) ?? {
            isNextMeData: false
          };
          if (isRecommendationData || nextToMyData.isNextMeData || criteria.length > 0) {
            this.store.dispatch(new GetCatalogGeoData(nextToMyData, isRecommendationData, criteria ?? '')).pipe(take(1));
          }
        })
      );
    }
  }

  public showCardClick(objectId: number | null): void {
    if (this.selectCatalog && objectId) {
      this.store.dispatch(new GetSelectCatalogItem(objectId, this.selectCatalog.id, this.isDynamic));
      this.showCard = true;
    } else {
      this.store.dispatch(new SelectCatalogItemShared(null));
      this.store.dispatch(new ChangeCatalogItem(null));
      this.showCard = false;
    }
  }
}
